export Footer from './Footer/Footer';
export Navbar from './Navbar/Navbar';
export NotFound from './NotFound/NotFound';
export Sidebar from './Sidebar/SideBar';
export { default as VerifyLogin } from './VerifyLogin';
